<template>
  <div class="flex flex-col justify-start items-center">
    <div v-if="passwordResetResponse" class="w-full">
      <div v-if="passwordResetResponse.invalid">
        <h5 class="w-full mb-4">Invalid credentials</h5>
        <button class="btn btn-cw-700 m-0" @click="resetForm">Okay</button>
      </div>
      <div v-else-if="isOrganisation">
        <h2 class="flex justify-start items-center space-x-2 w-full mb-4 mr-4">
          Your password has been reset.
        </h2>
        <button class="btn btn-cw-700 m-0" @click="closeAndReset">Okay</button>
      </div>
      <form
        v-else
        id="authenticate"
        ref="authenticate"
        method="POST"
        action="/account/authenticate"
      >
        <h2 class="flex justify-start items-center space-x-2 w-full mb-4 mr-4">
          Your password has been reset.
        </h2>
        <input type="hidden" name="_token" :value="csrf" />
        <input type="hidden" name="email" :value="emailInput" required="" />
        <input
          type="hidden"
          name="password"
          :value="passwordInput"
          required=""
        />
        <button class="btn btn-cw-700 m-0" type="submit">
          Go to your dashboard
        </button>
      </form>
    </div>
    <div v-else class="w-full">
      <h2 class="flex justify-start items-center space-x-2 w-full mb-4 mr-4">
        Reset Password
      </h2>

      <div class="flex flex-col space-y-4 items-start max-w-xl">
        <h5 v-if="emailInput" class="w-ful">
          <span class="text-cw-300">{{ emailInput }}</span>
        </h5>

        <div class="w-full">
          <p>New password</p>
          <input
            id="password"
            v-model="passwordInput"
            :class="'placeholder-truegray-300 text-gray-600 focus:text-gray-600 visited:text-gray-600 focus:ring-gray-600'"
            class="flex-grow px-4 outline-none focus:outline-none bg-transparent h-12 font-primary text-black focus:placeholder-truegray-300 rounded-lg relative bg-white border border-truegray-300 w-3/4"
            name="password"
            type="password"
            autocomplete="off"
            placeholder="enter a new password"
            @keyup="checkValidation"
            @change="checkValidation"
          />
        </div>

        <div class="w-full">
          <p>Confirm password</p>
          <input
            id="password2"
            v-model="passwordInput2"
            :class="'placeholder-truegray-300 text-gray-600 focus:text-gray-600 visited:text-gray-600 focus:ring-gray-600'"
            class="flex-grow px-4 outline-none focus:outline-none bg-transparent h-12 font-primary text-black focus:placeholder-truegray-300 rounded-lg relative bg-white border border-truegray-300 w-3/4"
            name="password2"
            type="password"
            autocomplete="off"
            placeholder="confirm password"
            @keyup="checkValidation"
            @change="checkValidation"
            @blur="checkPasswordsMatch"
          />
          <p v-if="passwordConfirmInvalid" class="text-sm text-red-500">
            Passwords do not match
          </p>
        </div>

        <div v-if="!sendSubmitResponse" class="relative text-left">
          <button
            :disabled="!canSubmit"
            :class="[!canSubmit ? 'opacity-25' : '', thinking ? '' : '']"
            class="relative rounded-lg py-4 px-8 text-white font-primary text-center ease-in-out duration-300 h-12 btn btn-cw-700 m-0"
            @click="submitReset"
          >
            <div class="flex justify-center items-center w-full h-full">
              <div
                class="absolute inset-0 w-full flex justify-center items-center z-20"
              >
                <lottie v-if="thinking" :options="loadingAnimationOptions" />
              </div>
              <div
                :class="[thinking ? 'invisible' : '']"
                class="w-full flex items-center justify-center"
              >
                Submit
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { shared } from '../../js/mixins/shared.js'
import { EventBus } from '../../js/plugins/event-bus.js'
import * as loadingAnimation from '../../shared/components/loading.json'
import { parseURLParams } from '../../js/util/helper.js'

export default {
  mixins: [shared],

  data() {
    return {
      passwordConfirmInvalid: false,

      passphrasetoken: false,

      authenticated: false,
      passwordResetResponse: false,
      csrf: false,

      loadingAnimationOptions: { animationData: loadingAnimation.default },
      loadingAnimate: false,

      canSubmit: false,
      thinking: false,

      emailInput: '',
      passwordInput: '',
      passwordInput2: '',

      sendSubmitResponse: false,
      resetPassword: false,

      isOrganisation: false,
    }
  },

  watch: {
    emailInput: {
      handler: function (val) {
        // Remove all white space from inputs...
        val = val.replace(/\s+/g, '') // or you can use your own preferred way to remove leading spaces
        this.$set(this, 'emailInput', val)
      },

      deep: true,
    },

    passwordInput: {
      handler: function (val) {
        // Remove all white space from inputs...
        val = val.replace(/\s+/g, '') // or you can use your own preferred way to remove leading spaces
        this.$set(this, 'passwordInput', val)
      },

      deep: true,
    },

    emailResetInput: {
      handler: function (val) {
        // Remove all white space from inputs...
        val = val.replace(/\s+/g, '') // or you can use your own preferred way to remove leading spaces
        this.$set(this, 'emailResetInput', val)
      },

      deep: true,
    },
  },

  mounted() {
    let urlparams = parseURLParams(window.location.href)
    let resetCentralToken = false
    let resetCentralEmail = false
    Object.keys(urlparams).forEach((key) => {
      if (key === 'resetlogin') {
        resetCentralToken = urlparams[key][0]
      }
      if (key === 'resetemail') {
        resetCentralEmail = urlparams[key][0]
      }
    })

    if (resetCentralToken) {
      this.$set(this, 'passphrasetoken', resetCentralToken)
    }

    if (resetCentralEmail) {
      this.$set(this, 'emailInput', resetCentralEmail)
    }

    let authenticated = document.getElementsByTagName('body')[0].dataset.admin
      ? true
      : false
    if (authenticated) {
      this.$set(this, 'authenticated', { redirect: true })
    }

    let token = document.head.querySelector('meta[name="csrf-token"]')
    if (token) {
      let csrf = token.getAttribute('content')
      this.$set(this, 'csrf', csrf)
    }

    // When the theme changes dynamically we also need to changed stored theme data variables...
    EventBus.$on('validateSignInEmail', (email) => {
      this.$set(this, 'emailInput', email)
      this.validateSignInEmail()
    })

    // When the theme changes dynamically we also need to changed stored theme data variables...
    EventBus.$on('modalAlertClose', () => {
      this.$set(this, 'sendSubmitResponse', false)
      this.$set(this, 'emailInput', '')
    })
  },

  methods: {
    resetForm() {
      EventBus.$emit('showModal', false)
    },

    checkPasswordsMatch() {
      if (this.passwordInput === this.passwordInput2) {
        this.$set(this, 'passwordConfirmInvalid', false)
      } else {
        this.$set(this, 'passwordConfirmInvalid', true)
      }
    },

    resetPasswordReset() {
      this.$set(this, 'sendSubmitResponse', false)
      this.$set(this, 'emailInput', '')
      this.$set(this, 'passwordInput', '')
      this.$set(this, 'authenticated', false)
      this.$set(this, 'passwordResetResponse', false)
    },

    closeAndReset() {
      EventBus.$emit('showModal', false)
    },

    hideLoginModal() {
      this.$set(this, 'sendSubmitResponse', false)
      this.$set(this, 'sendSubmitResponseSuccess', false)
      this.$set(this, 'emailInput', '')
    },

    checkValidation() {
      let canSubmit = false
      if (
        this.validateEmail(this.emailInput) &&
        this.passwordInput.length > 6 &&
        this.passwordInput2.length > 6 &&
        this.passwordInput === this.passwordInput2
      ) {
        canSubmit = true
      }

      if (
        this.passwordInput === this.passwordInput2 &&
        this.passwordInput.length > 0
      ) {
        this.$set(this, 'passwordConfirmInvalid', false)
      }

      this.$set(this, 'canSubmit', canSubmit)
    },

    submitReset() {
      if (!this.canSubmit) {
        return
      }

      this.$set(this, 'thinking', true)
      let submitData = {
        email: this.emailInput,
        password: this.passwordInput,
        password2: this.passwordInput2,
        token: this.passphrasetoken,
      }
      axios
        .post('/central-api/reset-password-confirm', submitData)
        .then((response) => {
          if (response?.data?.user?.role === 0) {
            this.$set(this, 'isOrganisation', true)
          }
          this.$set(this, 'sendSubmitResponse', true)
          this.$set(this, 'thinking', false)
          this.$set(this, 'canSubmit', true)

          let returned = response.data
          if (returned.success) {
            this.$set(this, 'passwordResetResponse', true)
          } else {
            this.$set(this, 'passwordResetResponse', { invalid: true })
          }
          if (returned.alert) {
            EventBus.$emit('triggerAlertResponse', {
              status: returned.alert.status,
              message: returned.alert.message,
            })
          }
        })
    },

    toggleResetPassword() {
      let resetStatus = !this.resetPassword
      this.$set(this, 'resetPassword', resetStatus)
    },
  },
}
</script>
